// import { ajaxPost,api } from '@/common/request.js'
export const utils = {
    getCurrentApi(){
        return 'test'//修改这里 prod
    } ,
    getIsPublic(){
        // return 'local'//修改这里 17746820252  YSzn20**
        return 'public'//修改这里
    } ,
    getSysId(){
      return 5//当前系统为乔司,代号为5
    },
    getToken_Yjj(){
        let oUserInfo=this.getCookie('userInfo_multiActive')?JSON.parse(this.getCookie('userInfo_multiActive')):{}
        return oUserInfo.yijiajiaUserToken
    },
    //用来存储信息到浏览器的函数
    getAdminId(){
        let oUser=this.getCookie('userInfo_multiActive')?JSON.parse(this.getCookie('userInfo_multiActive')):{}
        return oUser.adminId
    },
    getRoleId(){
        let oUser=this.getCookie('userInfo_multiActive')?JSON.parse(this.getCookie('userInfo_multiActive')):{}
        return oUser.roleId
    },

    setItem: function(key, value) {
        sessionStorage.setItem(key, value)
    },
    getItem: function(key) {
        let result = sessionStorage.getItem(key)
        return result
    },
    getCookie: function(cname) {
        var name = cname + "=";
        var formateCookie = decodeURIComponent(document.cookie)
        var ca =formateCookie.split(';');
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i].trim();
            if (c.indexOf(name) == 0) return c.substring(name.length, c.length);
        }
        return "";
    },
    setCookie: function(cname, cvalue, exdays) {
      console.log("=====调用setCookie=====:"+cname+';'+cvalue+';'+exdays)
        var d = new Date();
        d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
        var expires = "expires=" + d.toGMTString();
        // document.cookie = cname + "=" + cvalue + "; " + expires+ ";domain=yijiajiayun.com"
        let currentApi=this.getCurrentApi()
        if(currentApi=='dev'||currentApi=='test'||currentApi=='prod'){
            console.log('当前环境：'+currentApi)
            document.cookie = cname + "=" + encodeURIComponent(cvalue)  + "; " + ";domain=fzzht.com"
        }else{
            document.cookie = cname + "=" + encodeURIComponent(cvalue)  + "; " //本地的配置
        }
        if(this.getIsPublic()=='local'){
            document.cookie = cname + "=" + encodeURIComponent(cvalue)  + "; " //本地的配置
        }

    },
    getToken(){
        let oUserInfo=this.getCookie('userInfo_multiActive')?JSON.parse(this.getCookie('userInfo_multiActive')):{}
        return oUserInfo.userLoginToken
    },
    getPhone(){
        let oUserInfo=this.getCookie('userInfo_multiActive')?JSON.parse(this.getCookie('userInfo_multiActive')):{}
        return oUserInfo.phone
    },
    setBrowser(cname, cvalue, exdays) {
        this.setCookie(cname, cvalue, exdays)
    },
    getBrowser(cname) {
        return this.getCookie(cname)
    },
    //用来存储信息到浏览器的函数 end
    log(a) {
        console.log(a)
    },
    isEmptyObject: function(obj) {
        for (var key in obj) {
            return false; //返回false，不为空对象
        }
        return true; //返回true，为空对象
    },
    clearSearchObjSession(){//"清空搜索条件session"
        console.log("清空搜索条件session")
        sessionStorage.setItem('searchObjJson','')
    },
    setSearchObjToSession(obj){//保存的搜索条件
        console.log(obj,'保存的搜索条件')
        sessionStorage.setItem('searchObjJson',JSON.stringify(obj))
    },
    getSearchObjFromSession(){//获取搜索条件
        let result=sessionStorage.getItem('searchObjJson')?JSON.parse(sessionStorage.getItem('searchObjJson')):''
        return result
    },
    findTextFromValue(arr,value){
        let result=''
        if(arr&&arr.length>0){
            arr.forEach(function(item,index){
                if(item.value==value){
                    result=item.text
                    return false
                }
            })
        }
        return result
    },
    getCurrentFunction(){
        let result=[]
        if(sessionStorage.getItem('currentFunction_jgds')){
            result=JSON.parse(sessionStorage.getItem('currentFunction_jgds'))
        }
        return result
    },
    turnImgIdToJson_main(arr) {
        let result = arr.map(item => {
            return {
              ...item.wwId,
              isMain: item.isMain ? 1 : 0
            }
        });
        return JSON.stringify(result)
    },
    turnImgIdToJson(str){
      // console.log(str)
      // let result=''
      // if(str){
      //   let arr=str.split(",")
      //   let newArr=arr.map(function(item,index){
      //     return JSON.parse(item)
      //   })
      //   console.log(newArr)
      //   result=JSON.stringify(newArr)
      // }else{
      //   result=""
      // }
      // console.log(result)
      // return result
      // return JSON.stringify(str)
      let result=str.map(function(item,index){
        let buffer=item.wwId
        return buffer
      })
      return JSON.stringify(result)

    },
    getTagArrFromJson(json){
      let result=[]
      if(this.isJSON(json)){
        result=JSON.parse(json)
      }
      return result
    },
    getTagToJava(arr){//把标签加上ischosed 给后台
      // let result=[]
      // if(arr&&arr.length>0){
      //   arr.forEach(function(item,index){
      //     if(item.isChosed){
      //       result.push(item.tag_id)
      //     }
      //   })
      // }
      // return result.join(",")
      let result=[]
      if(arr&&arr.length>0){
        arr.forEach(function(item,index){
          let buffer={
            tag_id:item.tag_id,
            tag_name:item.tag_name,
            tag_icon:item.tag_icon,
            isChosed:item.isChosed
          }
          result.push(buffer)
        })
      }
      return JSON.stringify(result)
    },
    isJSON(str) {
        if (typeof str == 'string') {
            try {
                var obj=JSON.parse(str);
                if(typeof obj == 'object' && obj ){
                    return true;
                }else{
                    return false;
                }

            } catch(e) {
                // console.log('error：'+str+'!!!'+e);
                return false;
            }
        }
    },
    getActiveTagName(json){//从选项 ischosed 里获取名字展示
      let result=[]
      if(this.isJSON(json)){
        let arr=JSON.parse(json)
        if(arr.constructor==Array){
          arr.forEach(function(item,index){
            // console.log(item)
            if(item.isChosed){
              result.push(item.tag_name)
            }
          })
        }
      }
      return result.join(",")
      // return result
    },
    computeDjs: function(endDate, spanDay) {
        let result = ""
        if (!endDate || isNaN(new Date(endDate).getTime())) {
            result = "时间格式不正确"
        } else if (spanDay && isNaN(spanDay)) {
            result = "spanDay参数不正确 "
        } else {
            let endTime = ""
            if (!spanDay) {
                endTime = new Date(endDate).getTime()
            } else {
                let spanTime = parseFloat(spanDay) * 24 * 60 * 60 * 1000
                endTime = parseInt(new Date(endDate).getTime()) + parseInt(spanTime)
            }
            let nowTime = new Date().getTime()
            let leftTime = ""
            let timeFlag = ""
            if (nowTime >= endTime) {
                timeFlag = "超时:"
                leftTime = nowTime - endTime; // 相差的毫秒数
            } else {
                timeFlag = "剩余:"
                leftTime = endTime - nowTime; // 相差的毫秒数
            }
            let days = Math.floor(leftTime / (24 * 3600 * 1000)); // 计算出天数
            let leavel = leftTime % (24 * 3600 * 1000); // 计算天数后剩余的时间
            let hours = Math.floor(leavel / (3600 * 1000)); // 计算剩余的小时数
            let leavel2 = leavel % (3600 * 1000); // 计算剩余小时后剩余的毫秒数
            let minutes = Math.floor(leavel2 / (60 * 1000)); // 计算剩余的分钟数
            let seconds = parseInt(leftTime / 1000) % 60;
            let timeStr = days + '天' + hours + '时' + minutes + '分' + seconds + '秒';
            result = timeFlag + timeStr
        }
        return result
    },
}
// 数据字典
export const wordData = {
    icon_word: ['el-icon-s-order', 'el-icon-monitor', 'el-icon-share', "el-icon-s-platform",
        'el-icon-message-solid', 'el-icon-s-cooperation', 'el-icon-s-shop', 'el-icon-s-data',
        'el-icon-s-operation', 'el-icon-s-promotion', 'el-icon-s-home', 'el-icon-s-release', 'el-icon-s-tools',
        'el-icon-s-management', 'el-icon-s-opportunity', 'el-icon-s-help',
        'el-icon-s-custom', 'el-icon-s-grid', 'el-icon-picture', 'el-icon-s-flag'
    ],
    update_type :[{
        text: '静默更新',
        value: 1
    },{
      text: '推荐更新',
      value: 2
    },{
        text: '强制更新',
        value: 3
    }],
    user_type: [{
            text: '品牌商',
            value: '1'
        },
        {
            text: '生产商',
            value: '2'
        },
        {
            text: '设计师',
            value: '3'
        },
        {
            text: '版师/版房',
            value: '4'
        },
        {
            text: '面料商',
            value: '5'
        },
        {
            text: '辅料商',
            value: '6'
        },
        {
            text: '工作室/个人生产',
            value: '7'
        },
        {
            text: '采购方/买款',
            value: '8'
        },
        {
            text: '工艺供应商',
            value: '9'
        },

    ],
    app_apply_result:[//申请使用系统的审核结果
        {
            text: '有效待处理',
            value: '1'
        },
        {
            text: '正在跟进待审批',
            value: '2'
        },
        {
            text: '通过审批',
            value: '3'
        },
    ],
    auth_result: [{
            text: '已通过',
            value: 'y'
        },
        {
            text: '未通过',
            value: 'n'
        },
        {
            text: '待审核',
            value: 'p'
        },
        {
            text: '未提交',
            value: 'never'
        }
    ],
    invite_resource:[
        {
            text: '无效',
            value: '0'
        },
        {
            text: '不带邀请码的链接',
            value: '1'
        },
        {
            text: '带邀请码的链接',
            value: '2'
        },
        {
            text: '带邀请码的二维码',
            value: '3'
        },
        {
            text: '不带邀请码的二维码',
            value: '4'
        },
    ],
    token_type: [{
            text: '无效',
            value: '0'
        },
        {
            text: '衣加加',
            value: '1'
        },
        {
            text: 'YI++ PC用户端',
            value: '2'
        },
        {
            text: '所有业务中台及管理后台共用',
            value: '5'
        },
        {
            text: '发布会订货系统移动端前台',
            value: '50'
        },
        {
            text: '发布会订货系统PC端品牌商后台',
            value: '51'
        },
        {
            text: '数聚时尚信息平台移动端前台',
            value: '60'
        },
        {
            text: '数聚时尚信息平台PC端前台',
            value: '61'
        }
    ],
    pay_methods:[{
        text: '无效',
        value: '0'
    },
    {
        text: '线下pos刷卡',
        value: '100200'
    },
    {
        text: '线下支付宝扫码',
        value: '100210'
    },
    {
        text: '线下微信扫码',
        value: '100220'
    },
    {
        text: '支付宝wappay支付',
        value: '100400'
    },
    {
        text: '微信jsapi支付',
        value: '100500'
    },
    {
        text: '支付宝app支付',
        value: '100600'
    },
    {
        text: '微信app支付',
        value: '100700'
    }],
    order_type: [{
            text: '包工包料',
            value: 'oem'
        },
        {
            text: '来料加工',
            value: 'cmt'
        }
    ],
    order_pay_status:[
        {
          text: '已取消',
          value: '0'
        },
        {
          text: '未付款',
          value: '1'
        },
        {
          text: '已付款',
          value: '2'
        },
        {
          text: '已退款',
          value: '3'
        }
    ],
    order_status: [{
            text: '待接单',
            value: '10100'
        },
        {
            text: '接单超时',
            value: '10200'
        },
        {
            text: '待选生产商',
            value: '10300'
        },
        {
            text: '待补充详细资料',
            value: '10500'
        },
        {
            text: '待品牌商上传合同',
            value: '12100'
        },
        {
            text: '待生产商确认合同',
            value: '12300'
        },
        {
            text: '待品牌商上传定金支付凭证',
            value: '12900'
        },
        {
            text: '待生产商确认定金支付凭证',
            value: '13000'
        },
        {
            text: '待生产商交付大货',
            value: '13700'
        },
        {
            text: '待品牌商验收成衣',
            value: '16700'
        },
        {
            text: '待生产商确认验收结果',
            value: '18300'
        },
        {
            text: '待品牌商支付交货款',
            value: '18700'
        },
        {
            text: '待生产商确认交货款',
            value: '18800'
        },
        {
            text: '待品牌商支付尾款',
            value: '19300'
        },
        {
            text: '待生产商确认尾款',
            value: '19400'
        },
        {
            text: '待订单评价',
            value: '19600'
        },
        {
            text: '品牌商已评价',
            value: '19710'
        },
        {
            text: '生产商已评价',
            value: '19720'
        },
        {
            text: '完成',
            value: '19800'
        },
        {
            text: '已取消',
            value: '19900'
        }
    ]

}
export const json = {
    phoneReg: /^1(3|4|5|6|7|8|9)[0-9]{9}$/,
    platLists_dev: [
        {
            text: "生产加工模块管理后台",
            value: "1",
            url:'https://p.mgt.dev.yijiajiayun.com/#/home'
        },
        {
            text:"订货系统模块管理后台",
            value: "2",
            url:'https://d.mgt.dev.yijiajiayun.com/#/home'
        },
        {
            text:"技工大赛管理后台",
            value: "3",
            url:'https://tc.mgt.dev.yijiajiayun.com/#/home'
        },
        {
            text:"衣加加APP管理后台",
            value: "4",
            url:'https://a.mgt.dev.yijiajiayun.com/#/home'
        },
        {
            text:"乔司时尚地图管理后台",
            value: "5",
            url:'https://qs.mgt.dev.yijiajiayun.com/#/home'
        },
    ],
    platLists_test: [
        {
            text: "生产加工模块管理后台",
            value: "1",
            url:'https://p.mgt.test.yijiajiayun.com/#/home'
        },
        {
            text:"订货系统模块管理后台",
            value: "2",
            url:'https://d.mgt.test.yijiajiayun.com/#/home'
        },
        {
            text:"技工大赛管理后台",
            value: "3",
            url:'https://tc.mgt.test.yijiajiayun.com/#/home'
        },
        {
            text:"衣加加APP管理后台",
            value: "4",
            url:'https://a.mgt.test.yijiajiayun.com/#/home'
        },
        {
            text:"乔司时尚地图管理后台",
            value: "5",
            url:'https://qs.mgt.test.yijiajiayun.com/#/home'
        },
    ],
    platLists_prod: [
        {
            text: "生产加工模块管理后台",
            value: "1",
            url:'https://p.mgt.yijiajiayun.com/#/home'
        },
        {
            text:"订货系统模块管理后台",
            value: "2",
            url:'https://d.mgt.yijiajiayun.com/#/home'
        },
        {
            text:"技工大赛管理后台",
            value: "3",
            url:'https://tc.mgt.yijiajiayun.com/#/home'
        },
        {
            text:"衣加加APP管理后台",
            value: "4",
            url:'https://a.mgt.yijiajiayun.com/#/home'
        },
        {
            text:"乔司时尚地图管理后台",
            value: "5",
            url:'https://qs.mgt.yijiajiayun.com/#/home'
        },
    ],
    leftMenu_fake: [{
            menu_parent_id: 0,
            menu_id: 1, //增加
            menu_request_url: "/home",
            menu_name: "首页",
            menu_icon: "icon-shouye",
            menu_sequence: 1, //顺序 增加
            menu_isShow: true,
        },
        {
            menu_parent_id: 0,
            menu_id: 2, //增加
            menu_request_url: "/active",
            menu_name: "活动管理",
            menu_icon: "icon-kehu",
            menu_sequence: 2, //顺序 增加
            menu_isShow: 1,
            subMenu: [{
                    menu_parent_id: 2,
                    menu_id: 1, //增加
                    menu_request_url: "/active/auth",
                    menu_name: "活动审核",
                    menu_sequence: 2, //顺序 增加
                },
                {
                    menu_parent_id: 2,
                    menu_id: 1, //增加
                    menu_request_url: "/active/activeInner",
                    menu_name: "活动列表",
                    menu_sequence: 2, //顺序 增加
                },
            ],
        },
        {
            menu_parent_id: 0,
            menu_id: 2, //增加
            menu_request_url: "/customer",
            menu_name: "客户管理",
            menu_icon: "icon-kehu",
            menu_sequence: 2, //顺序 增加
            menu_isShow: 1,
            subMenu: [{
                    menu_parent_id: 2,
                    menu_id: 1, //增加
                    menu_request_url: "/customer/intro",
                    menu_name: "客户概况",
                    menu_sequence: 2, //顺序 增加
                },
                {
                    menu_parent_id: 2,
                    menu_id: 1, //增加
                    menu_request_url: "/customer/list",
                    menu_name: "客户列表",
                    menu_sequence: 2, //顺序 增加
                }
            ],
        },
        {
            menu_parent_id: 0,
            menu_id: 3, //增加
            menu_request_url: "/system",
            menu_name: "系统管理",
            menu_icon: "icon-kehu",
            menu_sequence: 2, //顺序 增加
            menu_isShow: 1,
            subMenu: [{
                    menu_parent_id: 3,
                    menu_id: 1, //增加
                    menu_request_url: "/system/leftMenuManager",
                    menu_name: "菜单管理",
                    menu_sequence: 2, //顺序 增加
                },
                {
                    menu_parent_id: 2,
                    menu_id: 1, //增加
                    menu_request_url: "/system/roleManager",
                    menu_name: "角色管理",
                    menu_sequence: 2, //顺序 增加
                },
                {
                    menu_parent_id: 2,
                    menu_id: 1, //增加
                    menu_request_url: "/system/userManager",
                    menu_name: "用户管理",
                    menu_sequence: 2, //顺序 增加
                },
                {
                    menu_parent_id: 2,
                    menu_id: 1, //增加
                    menu_request_url: "/system/functionManager",
                    menu_name: "开发配置",
                    menu_sequence: 2, //顺序 增加
                }
            ],
        },
        // {
        //     menu_parent_id: 0,
        //     menu_id: 3, //增加
        //     menu_request_url: "",
        //     menu_name: "系统管理",
        //     menu_icon: "",
        //     menu_sequence: 3, //顺序 增加
        //     menu_isShow: 1,
        //     subMenu: [{
        //             menu_parent_id: 3,
        //             menu_id: 1, //增加
        //             menu_request_url: "/leftMenuManager",
        //             menu_name: "菜单管理",
        //             menu_sequence: 1, //顺序 增加
        //         },
        //         {
        //             menu_parent_id: 3,
        //             menu_id: 2, //增加
        //             menu_request_url: "/roleManager",
        //             menu_name: "角色管理",
        //             menu_sequence: 2, //顺序 增加
        //         },
        //         {
        //             menu_parent_id: 3,
        //             menu_id: 3, //增加
        //             menu_request_url: "/powerManager",
        //             menu_name: "权限管理",
        //             menu_sequence: 3, //顺序 增加
        //         }
        //     ],
        // },
        {
            menu_parent_id: 0,
            menu_id: 4, //增加
            menu_request_url: "/order",
            menu_name: "订单管理",
            menu_icon: "icon-kehu",
            menu_sequence: 4, //顺序 增加
            menu_isShow: 1,
            subMenu: [{
                    menu_parent_id: 4,
                    menu_id: 1, //增加
                    menu_request_url: "/order/intro",
                    menu_name: "订单概况",
                    menu_sequence: 2, //顺序 增加
                },
                {
                    menu_parent_id: 4,
                    menu_id: 1, //增加
                    menu_request_url: "/order/list",
                    menu_name: "订单列表",
                    menu_sequence: 2, //顺序 增加
                },
            ],
        },
    ],
    tableData: [{
            date: '2016-05-03',
            name: 'qq1',
            address: '上海市普陀区金沙江路 1518 弄'
        },
        {
            date: '2016-05-03',
            name: 'ww1',
            address: '上海市普陀区金沙江路 1518 弄'
        },
        {
            date: '2016-05-03',
            name: 'werw1',
            address: '上海市普陀区金沙江路 1518 弄'
        },
        {
            date: '2016-05-03',
            name: 'qeqw1',
            address: '上海市普陀区金沙江路 1518 弄'
        },
        {
            date: '2016-05-03',
            name: 'sfa1',
            address: '上海市普陀区金沙江路 1518 弄'
        },
        {
            date: '2016-05-03',
            name: 'sdfd1',
            address: '上海市普陀区金沙江路 1518 弄'
        },
        {
            date: '2016-05-03',
            name: 'sdfds1',
            address: '上海市普陀区金沙江路 1518 弄'
        },
        {
            date: '2016-05-03',
            name: 'werwer1',
            address: '上海市普陀区金沙江路 1518 弄'
        },
        {
            date: '2016-05-03',
            name: '王小虎1',
            address: '上海市普陀区金沙江路 1518 弄'
        },
        {
            date: '2016-05-03',
            name: 'sfsdgr1',
            address: '上海市普陀区金沙江路 1518 弄'
        },
        {
            date: '2016-05-03',
            name: '7685671',
            address: '上海市普陀区金沙江路 1518 弄'
        }
    ],
}



// WEBPACK FOOTER //
// ./src/common/common.js